// Core
import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

// Chakra
import {
  Box,
  Button,
  Flex,
  Switch, Table, Tbody, Td,
  Text, Tr, useDisclosure,
} from '@chakra-ui/react';

// Components
import {
  GiveawaysActiveIcon,

} from 'components/Icons/Icons';
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';
import Card from 'components/Card/Card';
import Field from 'components/Fields';
import ErrorCard from 'components/Errors';
import SuccessCard from '../../../../components/Success';
import { Controller } from 'react-hook-form';
import Attention from '../../../../components/Modals/Attention';
import PartnerInput from './PartnerInput';

const ApiKeyEditContent = ({ form, onSubmit, isSubmitting, errorCard, isNew, handleDelete }) => {

  const {
    isOpen: isOpenDelete,
    onOpen: onOpenDelete,
    onClose: onCloseDelete,
  } = useDisclosure();

  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const history = useHistory();
  const handleCancelClick = useCallback(() => {
    history.push('/api-keys');
  }, [history]);

  const { control, register, handleSubmit, formState: { errors } } = form;

  return (
    <Box
      zIndex="9"
      position="relative"
    >
      <Breadcrumbs
        icon={GiveawaysActiveIcon}
        target="API Keys"
        url="#/api-keys"
        current="New API Key"
        variant="standart"
      />

      <form onSubmit={onSubmit}>

      <Flex
        gap="16px"
        position="absolute"
        mt="-92px"
        right="0"
        alignItems="center"
      >

        {isNew && (
          <Button
            variant="ghost-md"
            minW="120px"
            onClick={() => handleCancelClick()}
          >
            Cancel
          </Button>
        )}

        {!isNew && (
          <Button variant="ghost-md" w="120px" onClick={onOpenDelete}>
            Delete
          </Button>
        )}
        <Button
          isLoading={isSubmitting}
          variant="submit-md"
          w="120px"
          type='submit'
        >
          {!isNew ? 'Confirm' : 'Create'}
        </Button>

      </Flex>

      {errorCard && <ErrorCard error={errorCard} maxW="840px" />}
      {message && <SuccessCard message={message} maxW={'100%'} />}
      {error && <ErrorCard error={error} maxW={'100%'} />}

      <Box maxW="840px">

        <Text variant="title-lg" mt="40px" mb="14px">
          API Key info
        </Text>

        <Card padding="24px" mb="40px">

          <Controller
            name="isActive"
            control={control}
            render={({ field }) => (
              <Table mb={6}>
                <Tbody>
                  <Tr>
                    <Td verticalAlign="top" border="unset" p="0 0 0 0">
                      <Text variant="title">Is Active? </Text>
                    </Td>
                    <Td verticalAlign="top" border="unset" p="0 0 0 0">
                      <Switch
                        float="right"
                        isChecked={field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                      />
                    </Td>
                  </Tr>
                </Tbody>
              </Table>
            )}
          />

          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <Field
                id="name"
                label="Name"
                type="text"
                value={field.value}
                isValid={!errors.name}
                onChange={field.onChange}
                mb="24px"
              />
            )}
          />

          <Controller
            name="partnerId"
            control={control}
            render={({ field }) => (
              <PartnerInput
                isValid={!errors.partnerId}
                isDisabled={false}
                onChange={field.onChange}
                value={field.value}
                wrapperProps={{
                  mb: '24px',
                }}
              />
            )}
          />

        </Card>
      </Box>
      </form>
      <Attention
        variant="remove"
        handle={handleDelete}
        isOpen={isOpenDelete}
        onOpen={onOpenDelete}
        onClose={onCloseDelete}
      />
    </Box>
  );
};

export default ApiKeyEditContent;
